import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TalentHappyPathDataService } from '../../shared/service/talent-happy-path-data-service';
import { InitialInterviewQuestion } from 'src/typings';

@Component({
  selector: 'app-initial-interview-welcome-back-page',
  standalone: false,
  templateUrl: './initial-interview-welcome-back-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './initial-interview-welcome-back-page.component.scss'
})
export class InitialInterviewWelcomeBackPageComponent implements OnInit {

  talentName: string = '';

  /** Continue pressed. The container decides the next page, as it does for a returning quick-apply talent. */
  @Output() continue = new EventEmitter<void>();

  constructor(
    private talentHappyPathDataService: TalentHappyPathDataService) {
  }

  ngOnInit(): void {
    this.talentHappyPathDataService.talent$.subscribe(talent =>
        this.talentName = <string> (talent.preferredName ? talent.preferredName : talent.firstName));
  }

  clickContinue() {
    this.continue.emit();
  }

}
